import { Component } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { IonApp, IonContent } from '@ionic/angular/standalone';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { FloatingContactComponent } from './components/floating-contact/floating-contact.component';
import { CommonModule } from '@angular/common';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, IonApp, IonContent, RouterOutlet, HeaderComponent, FooterComponent, FloatingContactComponent],
  template: `
    <ion-app>
      <ion-content class="app-content">
        <app-header></app-header>
        <main class="main-content">
          <router-outlet></router-outlet>
        </main>
        <app-footer></app-footer>
        <app-floating-contact></app-floating-contact>
      </ion-content>
    </ion-app>
  `,
  styles: [`
    .app-content {
      --background: transparent;
      --padding-top: 0;
      --padding-bottom: 0;
      --padding-start: 0;
      --padding-end: 0;
    }
    
    .main-content {
      min-height: calc(100vh - 160px);
      padding-top: 80px;
      position: relative;
    }
  `]
})
export class AppComponent {
  title = 'QuadProSol - IT Solutions';

  constructor(
    private router: Router
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.scrollToTop();
    });
  }

  private scrollToTop(): void {
    // Try multiple scroll methods to ensure compatibility
    if (typeof window !== 'undefined') {
      // Method 1: Ionic content scroll
      const ionContent = document.querySelector('ion-content');
      if (ionContent) {
        ionContent.scrollToTop(300);
      }
      
      // Method 2: Window scroll (fallback)
      window.scrollTo({ top: 0, behavior: 'smooth' });
      
      // Method 3: Document scroll (additional fallback)
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }
  }
}
